import { grey } from "@mui/material/colors";
import Flx from "../../../../../components/layout/Flx";
import Txt from "../../../../../components/typography/Txt";

const EmptySectionDataContent = ({ icon, sx, children }) => {
  return (
    <Flx
      center
      column
      sx={{
        py: 4,
        svg: {
          fontSize: 40,
          color: grey[300],
          mb: 1,
        },
      }}
    >
      {icon}
      <Txt sx={{ color: grey[400], fontSize: "13px" }}>{children}</Txt>
    </Flx>
  );
};
export default EmptySectionDataContent;
